import { Identifiable, RecordModel } from "../core";
import { CloudDownloadOutlined, SyncOutlined } from "@ant-design/icons";

export interface INotionDatabase extends Identifiable {
  name: string;
  notion_id: string;
  parent_page_id: string;
  parent_page_title: string;
  synced_enabled: boolean;
}

export const NotionDatabaseModel: RecordModel<INotionDatabase> = {
  name: "Notion Database",
  path: "notion-databases",
  selectQuery: "",
  tableQuery: "",
  toString: r => !!r.parent_page_title ? `${r.parent_page_title} - ${r.name}` : r.name,
  customActions: [
    { name: 'Sync', path: 'sync', icon: <SyncOutlined /> },
    { isDetail: true, path: 'sync_calendar', name: 'Sync with Notion', icon: <CloudDownloadOutlined /> },
  ],
  customTableMappings: {
    ...Object.fromEntries(['created_at', 'modified_at', 'last_synced_at'].map(fieldName => ([fieldName, { omit: true }]))),
    notion_id: { render: r => <small>{r.notion_id}</small> },
    parent_page_id: { render: r => <small>{r.parent_page_id}</small> },
  },
  allowSearch: true
}
